import React, { Dispatch, SetStateAction } from "react";
import { useLocation } from "react-router-dom";
import { commonString } from "../../../../../../AdminApi/commFunc";
import { Input } from "../../../../../Input/Input";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";

interface FaqTitleInputProps {
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
  isEditMode: boolean;
}

export default function FaqTitleInput({
  title,
  setTitle,
  isEditMode,
}: FaqTitleInputProps) {
  const { pathname } = useLocation();

  const pageTitle = commonString(pathname).title;

  return (
    <FaqDetailRow>
      <FaqDetailLabel>제목</FaqDetailLabel>

      <Input
        style={{ width: "calc(100% - 148px)" }}
        placeholder={`${pageTitle} 제목 입력`}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        disabled={!isEditMode}
      />
    </FaqDetailRow>
  );
}
